<template>
  <card title="Edit Patient" :has-settings="false" :has-subtitle="false" class="patient-edit-card" auto-height>
    <template #content>
      <add-patient :is-sidebar="true" :patient-id="patientId" ref="patient"></add-patient>
    </template>
    <template #headerUtils>
      <button class="button is-primary is-outlined mr-2" @click="save">Save</button>
      <slot name="headerUtils"></slot>
    </template>
  </card>
</template>

<script>
import { defineAsyncComponent } from "vue"
const AddPatient = defineAsyncComponent(() => import("@/views/patient/AddPatient.vue"))
import Card from "@/components/card/Card.vue";

export default {
  name: "PatientEditCard",
  components: {Card, AddPatient},
  props: ['patientId'],
  methods: {
    async save() {
      const [err] = await this.$refs.patient.savePatient({ redirect: false })
      if (!err) {
        this.$buefy.toast.open({
          message: 'Patient saved successfully',
          type: 'is-success'
        });
      }
    }
  }
}
</script>

<style scoped lang="scss">
.patient-edit-card {
  :deep(.monitoring-card__content) {
    overflow: visible;
  }
}
</style>